import React from 'react';
import PlayerSvg from '../../public/player-silhouette.svg';

const PlayerCount = ({ count }) => {
    return (
        <div className={`flex gap-3 items-center justify-center bg-white/20 m-1 py-1 px-4 rounded-full`}>
            <PlayerSvg width={17} height={15} color={'#fff'} aria-label="playersvg"/>
            <h1 className="font-gBold text-s text-center">{count}</h1>
        </div>
    )
};

export default PlayerCount;